import { render, staticRenderFns } from "./AddTagDomainAssociationModal.vue?vue&type=template&id=36d2ab80&scoped=true"
import script from "./AddTagDomainAssociationModal.vue?vue&type=script&lang=js"
export * from "./AddTagDomainAssociationModal.vue?vue&type=script&lang=js"
import style0 from "./AddTagDomainAssociationModal.vue?vue&type=style&index=0&id=36d2ab80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2ab80",
  null
  
)

export default component.exports